module.exports = __webpack_public_path__ + "img/star_icon.06e9a347.svg";